<template>
  <div class="c-filter">
    <ul class="ul-reset mb-4">
      <li class="mb-2">
        <router-link
          to="/cursos"
          class="c-filter__link"
        >
          Cursos Online
        </router-link>
      </li>
      <li class="mb-2">
        <router-link
          to="/cursos/oferta"
          class="c-filter__link"
        >
          Cursos en Oferta
        </router-link>
      </li>
      <li class="mb-2">
        <router-link
          to="/cursos/nuevo"
          class="c-filter__link"
        >
          Cursos Nuevos
        </router-link>
      </li>
    </ul>

    <div v-if="!isSubscriber">
      <div class="c-hr"></div>
      <div class="c-filter__bordertb">
        <router-link
          to="/membresias"
          class="c-filter__link"
        >
          Sube a Premium
          <span class="pri-color fs-21 ms-2">
            <Icon icon="bi:star"/>
          </span>
        </router-link>
      </div>
    </div>

    <div class="c-hr"></div>

    <p class="fs-14 sec-light w-regular my-4">
      FILTRAR RESULTADOS
    </p>

    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <section class="my-4">
          <div class="row gy-3">
            <div class="col-12">
              <b-skeleton height="20px"></b-skeleton>
            </div>
            <div class="col-12">
              <b-skeleton height="20px"></b-skeleton>
            </div>
            <div class="col-12">
              <b-skeleton height="20px"></b-skeleton>
            </div>
          </div>
        </section>
      </template>

      <div class="c-accordion c-accordion--mobile my-4">
        <section>
          <button v-b-toggle.categories
            class="c-accordion-button__toggle">
            <p class="mb-0">
              Categorías
            </p>
            <span class="sec-medium c-accordion-button__toggle-icon">
              <Icon icon="charm:chevron-down"/>
            </span>
          </button>
          <b-collapse id="categories" class="mt-2 p-0">
            <section
              v-for="category of body.categories"
              :key="`course-category-${category.id}`"
            >
              <button v-b-toggle="`category-${category.id}`"
                class="c-accordion-button__toggle-sub justify-content-start">
                <span class="sec-medium fs-18 d-flex me-1">
                  <Icon icon="ant-design:plus-outlined"/>
                </span>
                <p class="mb-0">
                  {{category.name}}
                </p>
              </button>
              <b-collapse :id="`category-${category.id}`" class="mt-2 ms-4 ps-2">
                <div class="row gy-3">
                  <div class="col-12">
                    <label class="c-form-group__radio">
                      <input
                        v-model="filter.category"
                        type="radio"
                        class="d-none"
                        value="all"
                      >
                      <div class="d-flex align-items-center">
                        <div class="c-form-group__radio-circulo">
                          <div class="c-form-group__radio-subcirculo"></div>
                        </div>
                        <span class="sec-medium ms-2">
                          Todos los cursos
                        </span>
                      </div>
                    </label>
                  </div>
                  <div
                    v-for="subcategory of category.subcategories"
                    :key="`category-${subcategory.id}`"
                    class="col-12"
                  >
                    <label class="c-form-group__radio">
                      <input
                        v-model="filter.category"
                        type="radio"
                        class="d-none"
                        :value="subcategory.slug"
                      >
                      <div class="d-flex align-items-center">
                        <div class="c-form-group__radio-circulo">
                          <div class="c-form-group__radio-subcirculo"></div>
                        </div>
                        <span class="sec-medium ms-2">
                          {{subcategory.name}}
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
              </b-collapse>
            </section>
          </b-collapse>
        </section>

        <div class="c-hr my-2"></div>

        <section>
          <button v-b-toggle.country
            class="c-accordion-button__toggle">
            <p class="mb-0">
              Región
            </p>
            <span class="sec-medium c-accordion-button__toggle-icon">
              <Icon icon="charm:chevron-down"/>
            </span>
          </button>
          <b-collapse id="country" class="mt-2 p-0">
            <div class="row gy-3">
              <div class="col-12">
                <label class="c-form-group__radio">
                  <input
                    v-model="filter.country"
                    type="radio"
                    class="d-none"
                    value="all"
                  >
                  <div class="d-flex align-items-center">
                    <div class="c-form-group__radio-circulo">
                      <div class="c-form-group__radio-subcirculo"></div>
                    </div>
                    <span class="sec-medium ms-2">
                      Todos los cursos
                    </span>
                  </div>
                </label>
              </div>
              <div
                v-for="(country, icountry) of body.countries"
                :key="`country-${icountry}`"
                class="col-12"
              >
                <label class="c-form-group__radio">
                  <input
                    v-model="filter.country"
                    type="radio"
                    class="d-none"
                    :value="country.slug"
                  >
                  <div class="d-flex align-items-center">
                    <div class="c-form-group__radio-circulo">
                      <div class="c-form-group__radio-subcirculo"></div>
                    </div>
                    <span class="sec-medium ms-2">
                      {{country.name}}
                    </span>
                  </div>
                </label>
              </div>
            </div>
          </b-collapse>
        </section>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filter: {
        category: '',
        country: '',
      },
    };
  },
  props: ['loading', 'body'],
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.stateUser;
    },

    isSubscriber() {
      return this.isAuthenticated
        ? this.userData.subscriber
        : false;
    },
  },
  watch: {
    filter: {
      handler() {
        this.$emit('update:body', {
          ...this.body,
          category: this.filter.category,
          country: this.filter.country,
        });
      },
      deep: true,
    },
  },
};
</script>
